// 模组管理

import FetchData from '@ezviz/FetchData';
import intl from 'react-intl-universal';
import { message } from "antd";

// 获取模组列表数据
export const MANAGEMODULE_FETCH_LIST_LOADING = 'MANAGEMODULE_FETCH_LIST_LOADING';
export const MANAGEMODULE_FETCH_LIST_SUCCESS = 'MANAGEMODULE_FETCH_LIST_SUCCESS';
export const MANAGEMODULE_FETCH_LIST_FAILED = 'MANAGEMODULE_FETCH_LIST_FAILED';
// 删除模组
export const MANAGEMODULE_DELETE_MODULE_LOADING = 'MANAGEMODULE_DELETE_MODULE_LOADING';
export const MANAGEMODULE_DELETE_MODULE_SUCCESS = 'MANAGEMODULE_DELETE_MODULE_SUCCESS';
export const MANAGEMODULE_DELETE_MODULE_FAILED = 'MANAGEMODULE_DELETE_MODULE_FAILED';
// 新增模组
export const MANAGEMODULE_ADD_MODULE_LOADING = 'MANAGEMODULE_ADD_MODULE_LOADING';
export const MANAGEMODULE_ADD_MODULE_SUCCESS = 'MANAGEMODULE_ADD_MODULE_SUCCESS';
export const MANAGEMODULE_ADD_MODULE_FAILED = 'MANAGEMODULE_ADD_MODULE_FAILED';
// 编辑模组
export const MANAGEMODULE_EDIT_MODULE_LOADING = 'MANAGEMODULE_EDIT_MODULE_LOADING';
export const MANAGEMODULE_EDIT_MODULE_SUCCESS = 'MANAGEMODULE_EDIT_MODULE_SUCCESS';
export const MANAGEMODULE_EDIT_MODULE_FAILED = 'MANAGEMODULE_EDIT_MODULE_FAILED';


// 获取固件列表数据
export const MANAGEMODULE_FETCH_FIRMWARE_LIST_LOADING = 'MANAGEMODULE_FETCH_FIRMWARE_LIST_LOADING';
export const MANAGEMODULE_FETCH_FIRMWARE_LIST_SUCCESS = 'MANAGEMODULE_FETCH_FIRMWARE_LIST_SUCCESS';
export const MANAGEMODULE_FETCH_FIRMWARE_LIST_FAILED = 'MANAGEMODULE_FETCH_FIRMWARE_LIST_FAILED';
// 删除固件
export const MANAGEMODULE_DELETE_FIRMWARE_LOADING = 'MANAGEMODULE_DELETE_FIRMWARE_LOADING';
export const MANAGEMODULE_DELETE_FIRMWARE_SUCCESS = 'MANAGEMODULE_DELETE_FIRMWARE_SUCCESS';
export const MANAGEMODULE_DELETE_FIRMWARE_FAILED = 'MANAGEMODULE_DELETE_FIRMWARE_FAILED';
// 新增固件
export const MANAGEMODULE_ADD_FIRMWARE_LOADING = 'MANAGEMODULE_ADD_FIRMWARE_LOADING';
export const MANAGEMODULE_ADD_FIRMWARE_SUCCESS = 'MANAGEMODULE_ADD_FIRMWARE_SUCCESS';
export const MANAGEMODULE_ADD_FIRMWARE_FAILED = 'MANAGEMODULE_ADD_FIRMWARE_FAILED';
// 删除固件
export const MANAGEMODULE_DEL_FIRMWARE_LOADING = 'MANAGEMODULE_DEL_FIRMWARE_LOADING';
export const MANAGEMODULE_DEL_FIRMWARE_SUCCESS = 'MANAGEMODULE_DEL_FIRMWARE_SUCCESS';
export const MANAGEMODULE_DEL_FIRMWARE_FAILED = 'MANAGEMODULE_DEL_FIRMWARE_FAILED';
// 编辑固件
export const MANAGEMODULE_EDIT_FIRMWARE_LOADING = 'MANAGEMODULE_EDIT_FIRMWARE_LOADING';
export const MANAGEMODULE_EDIT_FIRMWARE_SUCCESS = 'MANAGEMODULE_EDIT_FIRMWARE_SUCCESS';
export const MANAGEMODULE_EDIT_FIRMWARE_FAILED = 'MANAGEMODULE_EDIT_FIRMWARE_FAILED';

// 新增固件版本
export const MANAGEMODULE_ADD_FIRMWARE_VERSION_LOADING = 'MANAGEMODULE_ADD_FIRMWARE_VERSION_LOADING';
export const MANAGEMODULE_ADD_FIRMWARE_VERSION_SUCCESS = 'MANAGEMODULE_ADD_FIRMWARE_VERSION_SUCCESS';
export const MANAGEMODULE_ADD_FIRMWARE_VERSION_FAILED = 'MANAGEMODULE_ADD_FIRMWARE_VERSION_FAILED';
// 编辑固件版本
export const MANAGEMODULE_EDIT_FIRMWARE_VERSION_LOADING = 'MANAGEMODULE_EDIT_FIRMWARE_VERSION_LOADING';
export const MANAGEMODULE_EDIT_FIRMWARE_VERSION_SUCCESS = 'MANAGEMODULE_EDIT_FIRMWARE_VERSION_SUCCESS';
export const MANAGEMODULE_EDIT_FIRMWARE_VERSION_FAILED = 'MANAGEMODULE_EDIT_FIRMWARE_VERSION_FAILED';


// 获取工具列表数据
export const MANAGEMODULE_FETCH_TOOL_LIST_LOADING = 'MANAGEMODULE_FETCH_TOOL_LIST_LOADING';
export const MANAGEMODULE_FETCH_TOOL_LIST_SUCCESS = 'MANAGEMODULE_FETCH_TOOL_LIST_SUCCESS';
export const MANAGEMODULE_FETCH_TOOL_LIST_FAILED = 'MANAGEMODULE_FETCH_TOOL_LIST_FAILED';
// 删除
export const MANAGEMODULE_DEL_TOOL_LOADING = 'MANAGEMODULE_DEL_TOOL_LOADING';
export const MANAGEMODULE_DEL_TOOL_SUCCESS = 'MANAGEMODULE_DEL_TOOL_SUCCESS';
export const MANAGEMODULE_DEL_TOOL_FAILED = 'MANAGEMODULE_DEL_TOOL_FAILED';
// 新增工具
export const MANAGEMODULE_ADD_TOOL_LOADING = 'MANAGEMODULE_ADD_TOOL_LOADING';
export const MANAGEMODULE_ADD_TOOL_SUCCESS = 'MANAGEMODULE_ADD_TOOL_SUCCESS';
export const MANAGEMODULE_ADD_TOOL_FAILED = 'MANAGEMODULE_ADD_TOOL_FAILED';
// 编辑工具
export const MANAGEMODULE_EDIT_TOOL_LOADING = 'MANAGEMODULE_EDIT_TOOL_LOADING';
export const MANAGEMODULE_EDIT_TOOL_SUCCESS = 'MANAGEMODULE_EDIT_TOOL_SUCCESS';
export const MANAGEMODULE_EDIT_TOOL_FAILED = 'MANAGEMODULE_EDIT_TOOL_FAILED';


// 获取模组列表数据
export function fetchManageModuleList(param = {}) {
  return (dispatch, getState) => {
    const {
      pageStart = 0,
      pageSize = 10,
    } = param;
    dispatch({
      type: MANAGEMODULE_FETCH_LIST_LOADING,
    });
    // 获取模组列表数据
    const url = `/iot/config/api/iot/support/modules?pageStart=${pageStart}&pageSize=${pageSize}`
    const fetchData = new FetchData(url, {
      method: 'GET',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          if (res.data && res.page) {
            dispatch({
              type: MANAGEMODULE_FETCH_LIST_SUCCESS,
              moduleList: res.data || [],
              moduleListTotal: res.page.total || 0,
            });
          } else {
            dispatch({
              type: MANAGEMODULE_FETCH_LIST_SUCCESS,
              moduleList: [],
              moduleListTotal: 0,
            });
          }
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_FETCH_LIST_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_FETCH_LIST_FAILED,
        });
      });
  };
}
// 删除单条模组记录
export function deleteManageModule(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId
    } = param;
    if (typeof moduleId === 'undefined') {
      message.warn('请选择一个模组')
      return;
    }
    dispatch({
      type: MANAGEMODULE_DELETE_MODULE_LOADING,
    });

    const url = `/iot/config/api/iot/support/module/${moduleId}`
    const fetchData = new FetchData(url, {
      method: 'DELETE',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_DELETE_MODULE_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_DELETE_MODULE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_DELETE_MODULE_FAILED,
        });
      });
  };
}

// 新增模组
export function addManageModule(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleName,
      modulePic,
      moduleSize,
      moduleDesc,
      circuitDiagram,
      moduleIntroductionDoc,
      communicationMode,
      developMode,
    } = param;
    const body = {
      moduleName,
      modulePic,
      moduleSize,
      moduleDesc,
      circuitDiagram,
      moduleIntroductionDoc,
      communicationMode,
      developMode,
    }
    dispatch({
      type: MANAGEMODULE_ADD_MODULE_LOADING,
    });

    const url = `/iot/config/api/iot/support/module`
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_ADD_MODULE_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_ADD_MODULE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_ADD_MODULE_FAILED,
        });
      });
  };
}
// 编辑单条模组记录
export function editManageModule(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleName,
      modulePic,
      moduleSize,
      moduleDesc,
      circuitDiagram,
      moduleIntroductionDoc,
      communicationMode,
      developMode,
      mid,
    } = param;
    if (typeof mid === 'undefined') {
      message.warn('请选择一个模组')
      return;
    }
    const body = {
      moduleName,
      modulePic,
      moduleSize,
      moduleDesc,
      circuitDiagram,
      moduleIntroductionDoc,
      communicationMode,
      developMode,
    }
    dispatch({
      type: MANAGEMODULE_EDIT_MODULE_LOADING,
    });

    const url = `/iot/config/api/iot/support/module/${mid}`
    const fetchData = new FetchData(url, {
      method: 'PUT',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_EDIT_MODULE_SUCCESS,
          });
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_EDIT_MODULE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_EDIT_MODULE_FAILED,
        });
      });
  };
}



// 固件相关接口
// 获取固件列表数据
export function fetchFirmwareList(param = {}) {
  return (dispatch, getState) => {
    const {
      pageStart = 0,
      pageSize = 10,
      moduleId,
      firmwareId,
      version,
    } = param;
    dispatch({
      type: MANAGEMODULE_FETCH_FIRMWARE_LIST_LOADING,
    });
    // 获取模组列表数据 待后台提供接口文档
    let url = `/iot/config/api/iot/support/firmware/list?moduleId=${moduleId}&pageIndex=${pageStart * pageSize}&pageSize=${pageSize}`;
    if (typeof firmwareId !== 'undefined') {
      url += `&firmwareId=${firmwareId}`;
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_FETCH_FIRMWARE_LIST_SUCCESS,
            firmwareList: res.data || [],
            firmwareListTotal: res.page.total || 0,
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_FETCH_FIRMWARE_LIST_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_FETCH_FIRMWARE_LIST_FAILED,
        });
      });
  };
}
// 新增固件
export function addFirmware(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      firmwareType,
      firmwareLabel,
      firmwareLabelEn,
      mainCategory,
      mainCategoryId,
    } = param;
    dispatch({
      type: MANAGEMODULE_ADD_FIRMWARE_LOADING,
    });
    // 新增固件
    const url = `/iot/config/api/iot/support/firmware/add`;
    const body = {
      moduleId,
      firmwareType,
      firmwareLabel,
      firmwareLabelEn,
      mainCategory,
      mainCategoryId,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_ADD_FIRMWARE_SUCCESS,
          });
          // 重新获取列表
          dispatch(fetchFirmwareList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_ADD_FIRMWARE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_ADD_FIRMWARE_FAILED,
        });
      });
  };
}
// 修改固件
export function editFirmware(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      firmwareId,
      firmwareType,
      firmwareLabel,
      firmwareLabelEn,
      mainCategory,
      mainCategoryId,
    } = param;
    dispatch({
      type: MANAGEMODULE_EDIT_FIRMWARE_LOADING,
    });
    // 修改
    const url = `/iot/config/api/iot/support/firmware/update`;
    const body = {
      moduleId,
      firmwareId,
      firmwareType,
      firmwareLabel,
      firmwareLabelEn,
      mainCategory,
      mainCategoryId,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_EDIT_FIRMWARE_SUCCESS,
          });
          // 重新获取列表
          dispatch(fetchFirmwareList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_EDIT_FIRMWARE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_EDIT_FIRMWARE_FAILED,
        });
      });
  };
}
// 新增固件版本
export function addFirmwareVersion(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      firmwareId,
      firmwareVersion,
      firmwareUrl,
      serialProtocolUrl,
      specification,
      categories,
      appVersionMin,
      parameterConfig,
      md5,
      size,
    } = param;
    dispatch({
      type: MANAGEMODULE_ADD_FIRMWARE_VERSION_LOADING,
    });
    // 新增固件版本
    const url = `/iot/config/api/iot/support/firmware/version/add`;
    const body = {
      moduleId,
      firmwareId,
      firmwareVersion,
      firmwareUrl,
      serialProtocolUrl,
      specification,
      categories,
      appVersionMin,
      parameterConfig,
      md5,
      size,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_ADD_FIRMWARE_VERSION_SUCCESS,
          });
          // 重新获取列表
          dispatch(fetchFirmwareList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_ADD_FIRMWARE_VERSION_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_ADD_FIRMWARE_VERSION_FAILED,
        });
      });
  };
}
// 修改固件版本
export function editFirmwareVersion(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      firmwarePackageId,
      firmwareVersion,
      firmwareUrl,
      serialProtocolUrl,
      specification,
      categories,
      appVersionMin,
      parameterConfig,
      md5,
      size,
    } = param;
    dispatch({
      type: MANAGEMODULE_ADD_FIRMWARE_VERSION_LOADING,
    });
    // 新增固件
    const url = `/iot/config/api/iot/support/firmware/version/update`;
    const body = {
      moduleId,
      firmwarePackageId,
      firmwareVersion,
      firmwareUrl,
      serialProtocolUrl,
      specification,
      categories,
      appVersionMin,
      parameterConfig,
      md5,
      size,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_ADD_FIRMWARE_VERSION_SUCCESS,
          });
          // 重新获取列表
          dispatch(fetchFirmwareList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_ADD_FIRMWARE_VERSION_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_ADD_FIRMWARE_VERSION_FAILED,
        });
      });
  };
}
// 删除固件或删除固件版本
export function delFirmware(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      firmwareId,
      firmwareVersion,
    } = param;
    dispatch({
      type: MANAGEMODULE_DEL_FIRMWARE_LOADING,
    });
    let url = `/iot/config/api/iot/support/firmware/delete?moduleId=${moduleId}&firmwareId=${firmwareId}`;

    // 有 firmwareVersion 参数则是删除固件版本
    if (typeof firmwareVersion !== 'undefined') {
      url += `&firmwareVersion=${firmwareVersion}`;
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_DEL_FIRMWARE_SUCCESS,
          });
          // 重新获取列表
          dispatch(fetchFirmwareList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_DEL_FIRMWARE_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_DEL_FIRMWARE_FAILED,
        });
      });
  };
}

// SDK工具相关接口
// 获取工具版本列表
export function fetchToolList(param = {}) {
  return (dispatch, getState) => {
    const {
      pageStart = 0,
      pageSize = 10,
      moduleId,
      toolVersion,
    } = param;
    dispatch({
      type: MANAGEMODULE_FETCH_TOOL_LIST_LOADING,
    });
    // 获取工具版本列表
    const url = `/iot/config/api/iot/support/sdkTool/list?moduleId=${moduleId}&pageIndex=${pageStart}&pageSize=${pageSize}`;
    const body = {
      pageIndex: pageStart,
      pageSize: pageSize,
    }
    if (typeof toolVersion !== 'undefined') {
      body.toolVersion = toolVersion;
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          if (res.data && res.page) {
            dispatch({
              type: MANAGEMODULE_FETCH_TOOL_LIST_SUCCESS,
              toolList: res.data || [],
              toolListTotal: res.page.total || 0,
            });
          } else {
            dispatch({
              type: MANAGEMODULE_FETCH_TOOL_LIST_SUCCESS,
              toolList: [],
              toolListTotal: 0,
            });
          }
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_FETCH_TOOL_LIST_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_FETCH_TOOL_LIST_FAILED,
        });
      });
  };
}
// 新增工具版本
export function addTool(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      toolVersion,
      toolUrl,
      sdkDoc,
    } = param;
    dispatch({
      type: MANAGEMODULE_ADD_TOOL_LOADING,
    });
    const url = `/iot/config/api/iot/support/sdkTool/version/add`;
    const body = {
      moduleId,
      toolVersion,
      toolUrl,
      sdkDoc,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_ADD_TOOL_SUCCESS,
            toolList: res.data || [],
            toolListTotal: res.total || 0,
          });
          dispatch(fetchToolList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_ADD_TOOL_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_ADD_TOOL_FAILED,
        });
      });
  };
}
// 修改工具版本
export function editTool(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      packageId,
      toolUrl,
      sdkDoc,
    } = param;
    dispatch({
      type: MANAGEMODULE_EDIT_TOOL_LOADING,
    });
    const url = `/iot/config/api/iot/support/sdkTool/version/update`;
    const body = {
      packageId,
      toolUrl,
      sdkDoc,
    }
    const fetchData = new FetchData(url, {
      method: 'POST',
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_EDIT_TOOL_SUCCESS,
            toolList: res.data || [],
            toolListTotal: res.total || 0,
          });
          dispatch(fetchToolList({ moduleId }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_EDIT_TOOL_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_EDIT_TOOL_FAILED,
        });
      });
  };
}
// 删除工具版本
export function delTool(param = {}, callback) {
  return (dispatch, getState) => {
    const {
      moduleId,
      toolVersion,
      pageStart
    } = param;
    dispatch({
      type: MANAGEMODULE_DEL_TOOL_LOADING,
    });
    const url = `/iot/config/api/iot/support/sdkTool/delete?moduleId=${moduleId}&toolVersion=${toolVersion}`;
    const fetchData = new FetchData(url, {
      method: 'POST',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res.code == 200) {
          dispatch({
            type: MANAGEMODULE_DEL_TOOL_SUCCESS,
            toolList: res.data || [],
            toolListTotal: res.total || 0,
          });
          dispatch(fetchToolList({ moduleId, pageStart }));
          callback && callback();
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
          dispatch({
            type: MANAGEMODULE_DEL_TOOL_FAILED,
          });
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
        dispatch({
          type: MANAGEMODULE_DEL_TOOL_FAILED,
        });
      });
  };
}
